'use strict';
module.exports = typeof navigator !== 'undefined' && /Version\/[\d\.]+.*Safari/.test(navigator.userAgent);



//////////////////
// WEBPACK FOOTER
// ./node_modules/is-safari/index.js
// module id = 509
// module chunks = 0